import { Pipe, PipeTransform } from '@angular/core';
import { TraceUtilsService } from '../services/trace-utils';
import { Request } from '../models/tracer.model';

@Pipe({
  name: 'getProviders',
})
export class GetProvidersPipe implements PipeTransform {
  constructor(private traceUtils: TraceUtilsService) {}

  transform(request: Request): string {
    return this.traceUtils.getProviders(request);
  }
}
